<template>
  <section class="montadoras">
    <div class="container custom-container">
      <p class="montadoras--title">
        Heliar é
        <span class="montadoras--highlight">a marca mais usada</span> pelas
        montadoras
      </p>
      <carousel
        class="montadoras--carrossel"
        :loop="true"
        :center="false"
        :autoplay="true"
        :autoheight="false"
        :autowidth="true"
        :dots="false"
        :nav="false"
        :responsive="{
          0: {
            stagePadding: 75,
            items: 2,
            margin: 25,
          },
          576: {
            margin: 35,
          },
          992: {
            items: 5,
            stagePadding: 100,
            margin: 40,
          },
          1201: {
            items: 7,
          },
        }"
      >
        <figure class="montadoras--logo">
          <img src="../assets/peugeot-logo.png" alt="Logo da Peugeot" />
        </figure>
        <figure class="montadoras--logo">
          <img src="../assets/renault-logo.png" alt="Logo da Renaut" />
        </figure>
        <figure class="montadoras--logo">
          <img src="../assets/citroen-logo.png" alt="Logo da Citroen" />
        </figure>
        <figure class="montadoras--logo">
          <img src="../assets/nissan-logo.png" alt="Logo da Nissan" />
        </figure>
        <figure class="montadoras--logo">
          <img src="../assets/suzuki-logo.png" alt="Logo da Suzuki" />
        </figure>
        <figure class="montadoras--logo">
          <img src="../assets/toyota-logo.png" alt="Logo da Toyota" />
        </figure>
        <figure class="montadoras--logo">
          <img src="../assets/hyundai-logo.png" alt="Logo da Hyundai" />
        </figure>
        <figure class="montadoras--logo">
          <img src="../assets/honda-logo.png" alt="Logo da Honda" />
        </figure>
        <figure class="montadoras--logo">
          <img src="../assets/mercedes-benz-logo.png" alt="Logo da Mercedes" />
        </figure>
        <figure class="montadoras--logo">
          <img src="../assets/mitsubishi-logo.png" alt="Logo da Mitsubishi" />
        </figure>
        <figure class="montadoras--logo">
          <img src="../assets/bmw-logo.png" alt="Logo da BMW" />
        </figure>
        <figure class="montadoras--logo">
          <img src="../assets/cherry-logo.png" alt="Logo da Cherry" />
        </figure>
        <figure class="montadoras--logo">
          <img src="../assets/land-rover-logo.png" alt="Logo da Land Rover" />
        </figure>
        <figure class="montadoras--logo">
          <img src="../assets/fiat-logo.png" alt="Logo da Fiat" />
        </figure>
      </carousel>
    </div>
  </section>
</template>

<script>
import carousel from "vue-owl-carousel";
export default {
  components: {
    carousel,
  },
};
</script>

<style lang="scss">
.montadoras {
  padding-bottom: 85px;
  &--title {
    font-size: 30px;
    line-height: normal;
    font-weight: 300;
    font-style: italic;
    color: $cinza-escuro;
    text-align: center;
    margin-bottom: 35px;
    text-transform: uppercase;
  }
  &--logo {
    max-width: 120px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-width: 100%;
      height: auto;
    }
  }
  &--carrossel {
    position: relative;
    .owl-item {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .owl-stage {
      display: flex;
      align-items: center;
    }
    .owl-stage-outer {
      &::after,
      &::before {
        content: "";
        width: 75px;
        height: 100%;
        position: absolute;
        top: 0;
        z-index: 1;
      }
      &::after {
        right: -1px;
        background: linear-gradient(
          to left,
          rgba(237, 237, 237, 1) 30%,
          rgba(237, 237, 237, 0.5) 80%,
          rgba(237, 237, 237, 0) 100%
        );
      }
      &::before {
        left: -1px;
        background: linear-gradient(
          to right,
          rgba(237, 237, 237, 1) 30%,
          rgba(237, 237, 237, 0.5) 80%,
          rgba(237, 237, 237, 0) 100%
        );
      }
    }
  }
  &--highlight {
    font-weight: 800;
  }
}
@media (max-width: 1200px) {
  .montadoras {
    &--title {
      font-size: 26px;
    }
  }
}
@media (max-width: 991px) {
  .montadoras {
    padding-bottom: 105px;
    padding-top: 105px;
    background-color: $second-bg-color;
    &--title {
      font-size: 46px;
      margin-bottom: 80px;
    }
    &--carrossel {
      .owl-stage-outer {
        &::after {
          right: -1px;
          background: linear-gradient(
            to left,
            rgba(248, 248, 248, 1) 30%,
            rgba(248, 248, 248, 0.502) 80%,
            rgba(248, 248, 248, 0) 100%
          );
        }
        &::before {
          left: -1px;
          background: linear-gradient(
            to right,
            rgba(248, 248, 248, 1) 30%,
            rgba(248, 248, 248, 0.502) 80%,
            rgba(248, 248, 248, 0) 100%
          );
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .montadoras {
    &--title {
      font-size: 30px;
    }
  }
}
@media (max-width: 575px) {
  .montadoras {
    padding-bottom: 100px;
    &--title {
      font-size: 28px;
      margin-bottom: 50px;
    }
    &--logos {
      max-width: 75px;
    }
    &--carrossel {
      .owl-stage-outer {
        &:after,
        &:before {
          width: 50px;
        }
      }
    }
  }
}
</style>
